var SUPERSTRONG = (!SUPERSTRONG ? {} : SUPERSTRONG);

(function($){
	SUPERSTRONG.dispatcher = !SUPERSTRONG.dispatcher ? $({}) : SUPERSTRONG.dispatcher;
	SUPERSTRONG.Breakpoint = function (){

		var _bp,
			breakpointSize,
			breakpoints
			;

		breakpoints = {

			large:'large,medium,small,xsmall',
			medium:'medium,small,xsmall',
			small:'small,xsmall',
			xsmall:'xsmall',

		}
		updateBreakPoint = function (){

			_bp = window.getComputedStyle(document.body,':before').getPropertyValue('content');
			_bp = _bp.replace(/['"]+/g, '');
			if (breakpointSize !== _bp){

				breakpointSize = _bp;
				SUPERSTRONG.dispatcher.trigger(SUPERSTRONG.events.breakpointChange,[breakpointSize]);
			}
		}

		SUPERSTRONG.dispatcher.isOnRange = function (bp){

			var bpString = breakpoints[breakpointSize];
			console.log (bpString,'<-',bpString.search(bp));
			if (bpString.search(bp)>-1){

				return true;

			}

			return false;

		}

		SUPERSTRONG.dispatcher.isRange = function (bp){

			if (breakpointSize.search(bp)>-1){

				return true;

			}

			return false;

		}

		$(window).resize (updateBreakPoint);
		$(document).ready(updateBreakPoint);

		SUPERSTRONG.dispatcher.breakpoint = breakpointSize;
		return SUPERSTRONG.dispatcher;
	};
})(jQuery)
